import React from "react";

/* ------------------------------------------------------------------ */
/*  Spinner                                                           */
/* ------------------------------------------------------------------ */

export interface SpinnerProps {
  /** Diameter in pixels. Defaults to 16. */
  size?: number;
  /** CSS color string. Defaults to currentColor. */
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Spinner = React.forwardRef<SVGSVGElement, SpinnerProps>(
  ({ size = 16, color = "currentColor", className, style, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        className={className}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="status"
        aria-label="Loading"
        style={{
          animation: "sf-spin 0.75s linear infinite",
          flexShrink: 0,
          ...style,
        }}
        {...rest}
      >
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="31.42 31.42"
          opacity="0.25"
        />
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="31.42 31.42"
          strokeDashoffset="20"
        />
      </svg>
    );
  },
);

Spinner.displayName = "Spinner";
export { Spinner };
